import {
  TourFormData,
  TourFormInputData,
} from '@/features/dashboard/tourConfig/schemas/tourSchema.ts';
import TourDto, {
  TourBaseDto,
} from '@/features/dashboard/tourConfig/types/TourDto.ts';
import timeUtils from '@/utils/timeUtils.ts';

export const tourDtoMapper = {
  fromFormToDto: (tour: TourFormData): TourBaseDto => {
    return {
      tourName: tour.tourName,
      destination: {
        country: tour.destination.country,
        city: tour.destination.city,
        street: tour.destination.street?.trim() || undefined,
        postalCode: tour.destination.postalCode?.trim() || undefined,
      },
      startDate: timeUtils.toJavaLocalDateTime(
        tour.startDate,
        tour.startDateTime,
      ),
      endDate: timeUtils.toJavaLocalDateTime(tour.endDate, tour.endDateTime),
      registrationStartDate: tour.registrationStartDate
        ? timeUtils.toJavaLocalDateTime(
            tour.registrationStartDate,
            tour.registrationStartDateTime,
          )
        : undefined,
      registrationEndDate: tour.registrationEndDate
        ? timeUtils.toJavaLocalDateTime(
            tour.registrationEndDate,
            tour.registrationEndDateTime,
          )
        : undefined,
      allowRegistrationDuringTour: tour.allowRegistrationDuringTour,
      tourOrganizerInsurance: tour.tourOrganizerInsurance,
      tourChatInviteLink: tour.tourChatInviteLink,
      participantLimit: tour.hasParticipantLimit ? tour.participantLimit : null,
    };
  },
  fromDtoToForm: (tour: TourDto): TourFormInputData => {
    return {
      tourName: tour.tourName,
      destination: {
        country: tour.destination.country,
        city: tour.destination.city,
        street: tour.destination.street,
        postalCode: tour.destination.postalCode,
      },
      startDate: new Date(tour.startDate),
      startDateTime: timeUtils.getTime(tour.startDate),
      endDate: new Date(tour.endDate),
      endDateTime: timeUtils.getTime(tour.endDate),
      registrationStartDate: tour.registrationStartDate
        ? new Date(tour.registrationStartDate)
        : undefined,
      registrationStartDateTime: tour.registrationStartDate
        ? timeUtils.getTime(tour.registrationStartDate)
        : undefined,
      registrationEndDate: tour.registrationEndDate
        ? new Date(tour.registrationEndDate)
        : undefined,
      registrationEndDateTime: tour.registrationEndDate
        ? timeUtils.getTime(tour.registrationEndDate)
        : undefined,
      allowRegistrationDuringTour: tour.allowRegistrationDuringTour ?? false,
      tourOrganizerInsurance: tour.tourOrganizerInsurance,
      tourChatInviteLink: tour.tourChatInviteLink,
      hasParticipantLimit:
        tour.participantLimit !== null && tour.participantLimit !== undefined,
      participantLimit: tour.participantLimit || undefined,
    };
  },
};
